// extracted by mini-css-extract-plugin
export default {"title":"DialogDuplicateDelete_title__suHBh"};